module.exports = __webpack_public_path__ + "static/12-48fe28913dca2bed01af7cbb4336557c.png";